import { useStaticQuery } from '../../../helpers/useStaticData';
import { getCart } from '../../../helpers/data';

export const useGetCartQuery = (userId) => useStaticQuery(() => getCart());
